import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getSettings } from './settings';
import { HttpError } from './http-error';
import { setupInterceptors } from './interceptors';
import { getAuthToken } from './auth';

let httpClient: AxiosInstance | null = null;

export function createHttpClient(): AxiosInstance {
  const settings = getSettings();

  if (!settings) {
    throw new Error('Settings not loaded');
  }

  const client = axios.create({
    baseURL: settings.apiEndpoint,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  client.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  setupInterceptors(client);

  return client;
}

export function getHttpClient(): AxiosInstance {
  if (!httpClient) {
    httpClient = createHttpClient();
  }
  return httpClient;
}

export async function get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  const response = await getHttpClient().get<T>(url, config);
  return response.data;
}

export async function post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
  const response = await getHttpClient().post<T>(url, data, config);
  return response.data;
}

export async function put<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
  const response = await getHttpClient().put<T>(url, data, config);
  return response.data;
}

export async function del<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  const response = await getHttpClient().delete<T>(url, config);
  return response.data;
}

export { HttpError };
